import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild, AfterViewInit, HostListener, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';

@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class PdfViewerComponent implements AfterViewInit {
    @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;
    @ViewChild('canvasContainer') canvasContainer!: ElementRef<HTMLDivElement>;

    @Input() url: string = './assets/default.pdf';

    @Output() isRead = new EventEmitter<boolean>();
    private pdfDoc: any;

    constructor() {
        // On pointe vers le worker copié dans les assets
        pdfjsLib.GlobalWorkerOptions.workerSrc = './assets/pdf.worker.min.js';
    }

    async ngAfterViewInit() {
        if (this.url) {
            await this.loadPDF(this.url);
        }
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes['url'] && !changes['url'].firstChange && this.url) {
            // Reset du conteneur avant de recharger
            this.canvasContainer.nativeElement.innerHTML = '';
            this.isRead.emit(false);
            await this.loadPDF(this.url);
        }
    }

    async loadPDF(url: string) {
        const loadingTask = pdfjsLib.getDocument(url);
        this.pdfDoc = await loadingTask.promise;

        for (let pageNum = 1; pageNum <= this.pdfDoc.numPages; pageNum++) {
            await this.renderPage(pageNum);
        }
    }

    private async renderPage(pageNum: number) {
        const page = await this.pdfDoc.getPage(pageNum);
        const viewport = page.getViewport({ scale: 1.5 }); // Ajustez le scale pour la netteté sur iPad

        const canvas = document.createElement('canvas');
        canvas.className = 'shadow-lg mx-auto max-w-full h-auto';
        const context = canvas.getContext('2d');

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
            canvasContext: context!,
            viewport: viewport
        };

        await page.render(renderContext).promise;
        this.canvasContainer.nativeElement.appendChild(canvas);
    }

    onScroll() {
        const element = this.scrollContainer.nativeElement;
        // Calcul de la position de scroll
        // On ajoute une marge de 20px pour la sensibilité sur iPad/WebView
        const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 20;

        if (atBottom) {
            this.isRead.emit(true);
        }
    }
}